<template>
  <div class="create">
		<div class="toast--wrapper">
		<transition name="toast_pushDown">
			<div class="toast" v-if="viewToast">
				<span>Claim saved</span>
			</div>
		</transition>
		</div>
		<div class="action_bar"></div>
		<main>
			<h1>Create</h1>

			<div class="permanent">
				<ul>
					<li>
						<button class="list_item" @click="viewClaimActive(true)">
							<div class="icon icon--claim placeholder"></div>
							<div>Claim</div>
						</button>
					</li>
					<li>
						<button class="list_item">
							<div class="icon icon--patient placeholder"></div>
							<div>Patient</div>
						</button>
					</li>
					<li>
						<button class="list_item">
							<div class="icon icon--group placeholder"></div>
							<div>Group</div>
						</button>
					</li>
				</ul>
			</div>

			<div class="templates">
				<div class="title_block">
					<h5>Claim from template</h5>
					<button class="edit_templates" @click="viewEditTemplates = true">Edit</button>
				</div>
				<ul>
					<!-- <li><button class="list_item" @click="viewTemplate3Active(true)">Template - Code + diagnosis combos</button></li>
					<li><button class="list_item" @click="viewTemplate2Active(true)">Template - One choice</button></li>
					<li><button class="list_item" @click="viewTemplate1Active(true)">Template - Full template</button></li> -->
					<li>
						<button class="list_item" @click="obs1 = true, viewToast = false, $store.commit('navBarModalActive', true)">
							<div class="template_list_item--name">Hospital birth</div>
							<div class="template_list_item--summary">
								<div class="billing_item">04008</div>
								<div class="separator">→</div>
								<div class="diagnosis">642</div>
								<div class="diagnosis">6510</div>
							</div>
						</button>
					</li>
					<li>
						<button class="list_item" @click="mel1 = true, viewToast = false, $store.commit('navBarMinimised', true)">
							<div class="template_list_item--name">Home dialysis</div>
							<div class="template_list_item--summary">
								<div class="billing_item">33761</div>
								<div class="separator">→</div>
								<div class="diagnosis">4340</div>
							</div>
						</button>
					</li>
					<li>
						<button class="list_item" @click="mel2 = true, viewToast = false, $store.commit('navBarMinimised', true)">
							<div class="template_list_item--name">Dialysis</div>
						</button>
					</li>

				</ul>
			</div>

			<button class="primary primary--labelsnap" @click="takeLabelSnap('standalone'), $store.commit('navBarModalActive', true), viewToast = false"><div class="icon icon--labelsnap placeholder"></div> Take LabelSnap</button>
		</main>


		<transition name="modal_fade">
			<Modal :modalZIndex="970" v-if="workspaceActiveExpanded" @click.native="minimiseWorkspace()"></Modal>
		</transition>

		<transition name="modal_fade">
			<Modal :modalZIndex="1020" v-if="labelSnapTemplate1" @click.native="minimiseWorkspace()"></Modal>
		</transition>

<!-- :class="{ 'action_bar--icon--close' : !labelSnapTaken, 'action_bar--icon--back' : labelSnapTaken, templateListActive : templateListActive }" -->
		<!-- TAKE LABELSNAP -->
		<transition name="modalView_slide">
			<ModalView class="camera"  :modalZIndex="1030" v-if="viewLabelSnap">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--close" @click="viewLabelSnap = false, $store.commit('navBarModalActive', false)" v-if="!labelSnapTaken"></button>
					<button class="icon48 action_bar--icon--back" @click="labelSnapTaken = false" v-if="labelSnapTaken"></button>
				</div>
				<div class="modalView--container">
					<div class="camera--window" :class="{ labelSnap_taken : labelSnapTaken }"></div>

					<div class="sample_labelsnap" v-if="!labelSnapTaken">
						<p>Make sure the image clearly shows the patient’s name, PHN, and DoB.</p>
						<img src="/img/sample_labelsnap.png" alt="" />
					</div>

					<div class="camera--shoot" v-if="!labelSnapTaken">
						<div class="camera--actions">
							<div class="action"><button @click="viewLabelSnap = false, $store.commit('navBarModalActive', false)">Close</button></div>
							<div class="shutter" @click="labelSnapTaken = true"></div>
							<div class="action"></div>
						</div>
					</div>

					<div class="camera--review" v-if="labelSnapTaken && !labelSnapStandalone">
						<!-- <button class="primary">Retake</button> -->
						<button class="primary" @click="viewLabelSnap = false">Use photo</button>
					</div>

					<div class="camera--review" v-if="labelSnapTaken && labelSnapStandalone">
						<h5>Apply to template</h5>
						<ul>
							<!-- <li><button class="list_item">Template - Normal</button></li>
							<li><button class="list_item" @click="viewTemplate3Active(true)">Template - Code + diagnosis combos</button></li>
							<li><button class="list_item" @click="viewTemplate2Active(true)">Template - One choice</button></li> -->
							<li><button class="list_item" @click="slideUpTemplate1 = true">Template - Full template</button></li>
							<li><button class="list_item" @click="obs1 = true">Hospital birth</button></li>
							<li><button class="list_item" @click="mel1 = true">Home dialysis</button></li>
						</ul>

						<!-- @click="viewLabelSnap = false, workspaceActive = true, labelSnapTaken = false, labelSnapStandalone = false" -->
						<!-- <button class="primary">Use in new claim</button> -->
						<button class="primary add_to_workspace_once" @click="$store.commit('modifyWorkspaceItems', 1), labelSnapTaken = false, labelSnapStandalone = false, viewLabelSnap = false, $store.commit('navBarModalActive', false)">Add to workspace</button>
						<button class="primary add_to_workspace_another" @click="$store.commit('modifyWorkspaceItems', 1), labelSnapTaken = false">&nbsp;</button>
					</div>

				</div>
			</ModalView>
		</transition>



		<!-- Start of modalSlideUp -->
    <ModalSlideUp :showComponents="slideUpTemplate1" @updateStatus="actionSheetActive = false">
			<ul class="slide_up--actions">
				
					<li>
						<div class="slide_up--actions--title">
							<h4>Confirm options</h4>
							<button class="expand">Expand</button>
						</div>
					</li>
				</ul>
					<!-- <li> -->

						<div class="group slide_up--actions--template1">
							<!-- <div class="title--wrapper"> -->
								<h5>Date</h5>
								<div class="date_picker">
									<button class="date_picker--previous" @click="$store.commit('decrementDate')"></button>
									<div class="date_picker--date">{{ getLastUsedDate() }}</div>
									<button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate')"></button>
								</div>
							<!-- </div> -->
						</div>
					<!-- </li> -->
				
			<!-- </ul> -->

			<!-- viewLabelSnap = false, viewTemplateList = false, labelSnapTemplate1 = false,  labelSnapTaken = false, viewToast = true, labelSnapStandalone = false -->
			<button class="primary slide_up_primary" @click="$store.commit('navBarModalActive', false), slideUpTemplate1 = false, viewLabelSnap = false, labelSnapTaken = false, labelSnapStandalone = false, viewToast = true">Save</button>
    </ModalSlideUp>
    <!-- End of modalSlideUp -->


		<transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1010" v-if="viewClaim">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewClaim = false"></button>
				</div>
				<div class="modalView--container">
					<h1>Create claim</h1>
					<p>Blank claim form.</p>
				</div>
			</ModalView>
		</transition>



		<!-- TEMPLATE 1 -->
		<transition name="modalView_slide">
			<ModalView v-if="viewTemplate1">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--close" @click="viewTemplate1 = false, $store.commit('navBarModalActive', false)"></button>
				</div>

				<div class="modalView--container template_1">
					<h2>Birth - Complicated</h2>
					<div class="summary">
						<table class="table--summary">
							<tr>
								<td colspan="2">
									<div class="diagnosis_cell">
										<div>00012 <span>/</span> 01838 <span>/</span> 01839</div>
										<div>0021</div>
									</div>
								</td>
							</tr>
							<tr>
								<td colspan="2">
									<div class="diagnosis_cell">
										<div>01888</div>
										<div>35B</div>
									</div>
								</td>
							</tr>
						
							<tr class="table--border--top">
								<td class="title">Location</td>
								<td>Hospital inpatient (I)</td>
							</tr>
							<tr>
								<td class="title">Rural</td>
								<td>Blueberry River</td>
							</tr>
							<tr>
								<td class="title">Payee</td>
								<td>987654</td>
							</tr>
						</table>
					</div>
					
					<div class="group inline_control">
						<div class="title--wrapper">
							<h5>Date</h5>
							<div class="date_picker">
								<button class="date_picker--previous" @click="$store.commit('decrementDate')"></button>
								{{ getLastUsedDate() }}
								<button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate')"></button>
							</div>
						</div>
					</div>

					<div class="group">
						<h5>Patients</h5>
						<div class="takeLabelSnap" :class="{ active : labelSnapTaken }"><button @click="takeLabelSnap('inClaim')">Take LabelSnap</button></div>
					</div>

					<button class="primary fixed" :class="{ disabled : !labelSnapTaken, active : labelSnapTaken }" @click="saveClaim(), $store.commit('navBarModalActive', false)" :disabled="!labelSnapTaken">Submit</button>
				</div>

			</ModalView>
		</transition>


		<!-- TEMPLATE 2 -->
		<transition name="modalView_slide">
			<ModalView v-if="viewTemplate2">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--close" @click="$store.commit('navBarModalActive', false), viewTemplate2 = false"></button>
				</div>

				<div class="modalView--container template_2">
					<h2>Birth - Complicated</h2>
					<div class="summary">
						<table class="table--summary">
							<tr>
								<td colspan="2">
									<div class="diagnosis_cell">
										<div>33761</div>
									</div>
								</td>
							</tr>
							<tr class="table--border--top">
								<td class="title">Location</td>
								<td>Hospital inpatient (I)</td>
							</tr>
							<tr>
								<td class="title">Rural</td>
								<td>Alexis Creek</td>
							</tr>
							<tr>
								<td class="title">Payee</td>
								<td>987654</td>
							</tr>
						</table>
					</div>

					<div class="group inline_control">
						<div class="title--wrapper">
							<h5>Date</h5>
							<div class="date_picker">
								<button class="date_picker--previous" @click="$store.commit('decrementDate')"></button>
								{{ getLastUsedDate() }}
								<button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate')"></button>
							</div>
						</div>
					</div>

					<div class="group">
						<div class="title--wrapper">
							<h5>Diagnoses</h5>
							<button class="button--action" @click="diagnosisDescriptionSwitchStatus = !diagnosisDescriptionSwitchStatus">{{ diagnosisDescriptionSwitchStatus ? 'Compact' : 'Detailed' }}</button>
						</div>

						<ul class="diagnoses_list" :class="{ compact : !diagnosisDescriptionSwitchStatus }">
							<li>
								<button class="list_item diagnosis checkbox" :class="{ active : diagnosis1 }" @click="diagnosis1 = !diagnosis1">
									5810
									<div class="minor" v-if="diagnosisDescriptionSwitchStatus">With lesion of proliferative glomerulonephritis</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis checkbox" :class="{ active : diagnosis2 }" @click="diagnosis2 = !diagnosis2">
									5811
									<div class="minor" v-if="diagnosisDescriptionSwitchStatus">With lesion of membraneous glomerulonephritis</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis checkbox" :class="{ active : diagnosis3 }" @click="diagnosis3 = !diagnosis3">
									5812
									<div class="minor" v-if="diagnosisDescriptionSwitchStatus">With lesion of membranoproliferative glomerulonephritis</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis checkbox" :class="{ active : diagnosis4 }" @click="diagnosis4 = !diagnosis4">
									5813
									<div class="minor" v-if="diagnosisDescriptionSwitchStatus">With lesion of minimal change glomerulonephritis</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis checkbox" :class="{ active : diagnosis5 }" @click="diagnosis5 = !diagnosis5">
									5818
									<div class="minor" v-if="diagnosisDescriptionSwitchStatus">With other specified pathological lesoin in kidney</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis checkbox" :class="{ active : diagnosis6 }" @click="diagnosis6 = !diagnosis6">
									5819
									<div class="minor" v-if="diagnosisDescriptionSwitchStatus">Unspecified</div>
								</button>
							</li>
						</ul>
					</div>

					<div class="group">
						<h5>Patients</h5>
						<div class="takeLabelSnap" :class="{ active : labelSnapTaken }"><button @click="takeLabelSnap('inClaim')">Take LabelSnap</button></div>
					</div>

					<button class="primary" :class="{ disabled : !labelSnapTaken, active : labelSnapTaken }" @click="saveClaim(), $store.commit('navBarModalActive', false);" :disabled="!labelSnapTaken">Submit</button>
				</div>

			</ModalView>
		</transition>


		<!-- TEMPLATE 3 -->
		<transition name="modalView_slide">
			<ModalView v-if="viewTemplate3">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--close" @click="$store.commit('navBarModalActive', false), viewTemplate3 = false"></button>
				</div>

				<div class="modalView--container template_3">
					<h2>Birth - After hours</h2>
					<div class="summary">
						<table class="table--summary">
							<tr>
								<td class="title">Location</td>
								<td>Practitioner's office, in publically administered facility (T)</td>
							</tr>
							<tr>
								<td class="title">Rural</td>
								<td>Courtenay / Comox / Cumberland</td>
							</tr>
							<tr>
								<td class="title">Payee</td>
								<td>987654</td>
							</tr>
						</table>
					</div>
					
					<div class="group inline_control">
						<div class="title--wrapper">
							<h5>Date</h5>
							<div class="date_picker">
								<button class="date_picker--previous" @click="$store.commit('decrementDate')"></button>
								{{ getLastUsedDate() }}
								<button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate')"></button>
							</div>
						</div>
					</div>

					<div class="group">
						<div class="title--wrapper">
							<h5>Billing codes & Diagnoses</h5>
						</div>
						<ul>
							<li>
								<button class="list_item diagnosis radio" :class="{ active : billingCombo1 }" @click="selectBillingCombo(1)">
									<div class="diagnosis_cell">
										<div>00012 <span>/</span> 01838 <span>/</span> 01839</div>
										<div>0021</div>
									</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis radio" :class="{ active : billingCombo2 }" @click="selectBillingCombo(2)">
									<div class="diagnosis_cell">
										<div>01622 <span>/</span> 01626</div>
										<div>0023</div>
									</div>
								</button>
							</li>
							<li>
								<button class="list_item diagnosis radio" :class="{ active : billingCombo3 }" @click="selectBillingCombo(3)">
									<div class="diagnosis_cell">
										<div>00018 <span>/</span> 00122</div>
										<div>38B</div>
									</div>
								</button>
							</li>
						</ul>
					</div>

					<div class="group">
						<h5>Patients</h5>
						<div class="takeLabelSnap" :class="{ active : labelSnapTaken }"><button @click="takeLabelSnap('inClaim')">Take LabelSnap</button></div>
					</div>

					<button class="primary" :class="{ disabled : !labelSnapTaken, active : labelSnapTaken }" @click="saveClaim(), $store.commit('navBarModalActive', false);" :disabled="!labelSnapTaken">Submit</button>
				</div>

			</ModalView>
		</transition>


    <!-- <transition name="slideUp_slide">
			<SlideUp class="action_bar--icon--chevron--down slideUp--action_sheet" :modalZIndex="1020" :title="'sdfdsf'" @closeSlideUp="alert('asd')" v-if="labelSnapTemplate1">
				<div class="pull"></div>

				<ul class="slide_up--actions">
					<li>
						<div class="slide_up--actions--title">
							<h4>Confirm options</h4>
							<button class="expand">Expand</button>
						</div>
					</li>
					<li>
						<div class="group inline_control">
							<div class="title--wrapper">
								<h5>Date</h5>
								<div class="date_picker">
									<button class="date_picker--previous" @click="$store.commit('decrementDate')"></button>
									{{ getLastUsedDate() }}
									<button class="date_picker--next" :disabled="$store.state.lastUsedDate == 'Today'" @click="$store.commit('incrementDate'), labelSnapTaken = false"></button>
								</div>
							</div>
						</div>
					</li>
				</ul>

				<button class="primary" @click="viewLabelSnap = false, viewTemplateList = false, labelSnapTemplate1 = false,  labelSnapTaken = false, viewToast = true, labelSnapStandalone = false">Save</button>
			</SlideUp>
    </transition> -->


    <transition name="modalView_pushLeft">
			<ModalView class="templates--edit background--grey" :modalZIndex="1200" v-if="viewEditTemplates">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewEditTemplates = false"></button>
					<button class="action_bar--text_action" @click="viewAddTemplate = true">Add</button>
				</div>
				<div class="modalView--container modalView--templates">
					<h1>Edit templates</h1>

					<ul>
						<li>
							<button @click="viewEditTemplate1 = true">Hospital birth</button>
							<button class="rearrange"></button>
						</li>
						<li>
							<button @click="viewEditTemplate1 = true">Home dialysis</button>
							<button class="rearrange"></button>
						</li>
						<!-- <li>
							<button @click="viewEditTemplate1 = true">Template - One choice</button>
							<button class="rearrange"></button>
						</li>
						<li>
							<button @click="viewEditTemplate1 = true">Template - Full template</button>
							<button class="rearrange"></button>
						</li> -->
					</ul>
				</div>
			</ModalView>
    </transition>


    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1210" v-if="viewAddTemplate">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewAddTemplate = false"></button>
				</div>
				<div class="modalView--container modalView--templates add">
					<h1>Add template</h1>
					<div class="nav--claim">
						<button :class="{ active : templatesTab1Active }" @click="templatesTab1()">For you</button>
						<button :class="{ active : templatesTab2Active }" @click="templatesTab2()">Speciality</button>
						<button :class="{ active : templatesTab3Active }" @click="templatesTab3()">New</button>
					</div>
					<div class="for_you" v-if="templatesTab1Active">
						<p>We've created templates just for you based on your claims history.</p>
						<ul>
							<li><button>Facility visit - 1st of day</button></li>
							<li><button>Facility visit</button></li>
						</ul>
					</div>
					<div class="speciality" v-if="templatesTab2Active">
						<p>Start with a template for your specialty and customise to suit the items that you use in your claims.</p>
						<ul>
							<li><button>Acupuncture</button></li>
							<li><button>Anaesthesia</button></li>
							<li><button>Cardiac surgery</button></li>
							<li><button>Cardiology</button></li>
							<li><button>Chiropractors</button></li>
							<li><button>Clinical immunisation and allergy</button></li>
							<li><button>Councellor / Psychologist - PHCO only</button></li>
							<li><button>Critical care medicine</button></li>
							<li><button>Dental surgeons</button></li>
							<li><button>Dermatology</button></li>
							<li><button>Educator - PHCO only</button></li>
							<li><button>Emergency medicine</button></li>
							<li><button>Endocrinology</button></li>
							<li><button>Gastroenterology</button></li>
							<li><button>General practice</button></li>
							<li><button>General surgery</button></li>
							<li><button>Geriatric medicine</button></li>
							<li><button>Hematology oncology</button></li>
							<li><button>Home support - PHCO only</button></li>
						</ul>
					</div>
					<div class="new" v-if="templatesTab3Active">
						<p>It's easiest to start with a pre-made template and customise it to your needs, but you can start from scratch if desired.</p>
						<ul>
							<li><button>Create new template</button></li>
						</ul>
						<!-- <button class="primary">Create new template</button> -->
					</div>
				</div>
			</ModalView>
    </transition>


    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1210" v-if="viewEditTemplate1">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="viewEditTemplate1 = false, actionMenu = false"></button>
					<!-- <button class="action_bar--text_action destructive">Delete</button> -->
					<button class="action_menu" :class="{active : actionMenu}">
						<div class="action_menu--title" @click="actionMenu = !actionMenu">Actions</div>
						<div class="action_menu--curve" v-if="actionMenu"></div>
						<div class="action_menu--dropdown" v-if="actionMenu">
							<ul>
								<li class="action_menu--dropdown--border"><button>Duplicate</button></li>
								<!-- <li class="action_menu--dropdown--border"><button>Share patient profile</button></li> -->
								<li><button style="color: red">Delete</button></li>
							</ul>
						</div>
					</button>
				</div>
				<div class="modalView--container">
					<h1>Template</h1>
					<p>Edit the template.</p>
				</div>
			</ModalView>
    </transition>



		<!-- DIALYSIS -->
    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="mel2">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="mel2 = false, $store.commit('navBarMinimised', false)"></button>
					<!-- <h2>Dialysis claim</h2> -->
					<!-- <div>
						<button class="action_bar--text_action">Edit</button>
						<button class="action_bar--text_action" @click="mel1_showAll = !mel1_showAll">Expand</button>
					</div> -->
				</div>

				<div class="modalView--container template">
					<h1>Dialysis</h1>
					
					<div class="title">
						<h5>Date of service</h5>
					</div>
					<div class="date_slider--wrapper">
						<div class="date_slider--calendar" @click="launchDatePicker()"></div>
						<div class="date_slider">
							<div v-for="cell in $store.state.templateDates" class="date_slider--cell" :class="{ active : cell.active }" :key="cell.code" @click="$store.commit('selectDate', cell)">
								<div class="date_slider--cell--day">{{ cell.day }}</div>
								<div class="date_slider--cell--date">{{ cell.date }}</div>
							</div>
						</div>
					</div>

					<div class="title" v-if="mel1Patients_showAll">
						<h5>Patients</h5>
					</div>

					<ul class="template--list template--list--remove active_patients">
						<li v-for="patient in $store.state.mel1Patients" :key="patient.id" :class="{ active : patient.active }" @click="$store.commit('mel1RemovePatientFromClaim', patient.id)">
							<div class="details">
								<div class="billing_item--code"><span class="name--first">{{ Patients.methods.getPatientObject(patient.id).firstName }}</span> {{ Patients.methods.getPatientObject(patient.id).lastName }}</div>
							</div>
						</li>

						<li v-for="group in $store.state.mel1Groups" :key="group.id" class="active active_group active_group--in_claim" @click="$store.commit('mel1RemoveGroupFromClaim', group.id)">
							<div class="details">
								<div class="billing_item--code"><span class="name--first">{{ Groups.methods.getGroupObject(group.id).name }}</span></div>
							</div>
							<div class="group_count">18</div>
						</li>
					</ul>

					<div class="patient--add_actions" v-if="$store.state.mel1Patients.length == 0 && $store.state.mel1Groups.length == 0">
						<button class="primary primary--patient_add">+ LabelSnap</button>
						<button class="primary primary--patient_add" @click="mel1PatientsSlideUp = true">+ Patient</button>
						<button class="primary primary--patient_add" @click="mel1GroupsSlideUp = true">+ Group</button>
					</div>

					<div class="patient--add_actions" v-if="$store.state.mel1Patients.length > 0">
						<button class="primary primary--patient_add">+ LabelSnap</button>
						<button class="primary primary--patient_add" @click="mel1PatientsSlideUp = true">+ Patient</button>
					</div>

					<div class="patient--add_actions" v-if="$store.state.mel1Patients.length == 0 && $store.state.mel1Groups.length > 0">
						<button class="primary primary--patient_add" disabled>+ LabelSnap</button>
						<button class="primary primary--patient_add" disabled @click="mel1PatientsSlideUp = true">+ Patient</button>
						<button class="primary primary--patient_add" disabled @click="mel1GroupsSlideUp = true">+ XGroup</button>
					</div>


					<div class="title">
						<h5>Billing items</h5>
						<button class="button--text" @click="mel1BillingItemsSlideUp = true">Other</button>
					</div>

					<ul class="template--list billing_item">
						<li v-for="cell in $store.state.mel1BillingItems" :key="cell.code" :class="{ active : cell.active }" @click="cell.active = !cell.active">
							<div class="details">
								<div class="billing_item--code">{{ cell.code }}</div>
								<div class="billing_item--description">{{ BillingItems.methods.getBillingItemObject(cell.code).name }}</div>
							</div>
							<div class="amount">{{ BillingItems.methods.getBillingItemObject(cell.code).amount }}</div>
						</li>
					</ul>
					
					<div class="title">
						<h5>Diagnoses</h5>
						<!-- <button class="button--text" @click="mel1Diagnoses_showAll = !mel1Diagnoses_showAll" v-if="!mel1Diagnoses_showAll">More</button> -->
						<button class="button--text" @click="mel1DiagnosesSlideUp = true">Other</button>
					</div>						
						<ul class="template--list diagnoses" style="width: 100%">
							<li v-for="diagnosis in $store.state.mel1Diagnoses" :key="diagnosis.code" :class="{ active : diagnosis.active }" @click="diagnosis.active = !diagnosis.active">
								<div class="billing_item--code">{{ diagnosis.code }}</div>
								<div class="billing_item--description">{{ Diagnoses.methods.getDiagnosis(diagnosis.code).name }}</div>
							</li>
						</ul>

					<div class="title">
						<h5>Service location</h5>
						<button class="button--text" @click="mel1PhysiciansSlideUp = true">Other</button>
					</div>
					<ul class="template--list template--list--radio service_location">
						<li v-for="location in $store.state.mel1ServiceLocations" :key="location.code" :class="{ active : location.active }" v-show="location.templated || mel1_showAll || mel1ServiceLocation_showAll" @click="$store.commit('selectMel1ServiceLocation', location)">
							<div class="service_location--name">{{ location.name }}</div>
							<div class="service_location--code">{{ location.code }}</div>
						</li>
					</ul>

					<div class="title">
						<h5>Referring physician</h5>
						<button class="button--text" @click="mel1PhysiciansSlideUp = true">Other</button>
					</div>
					<ul class="template--list template--list--radio referring_physicians">
						<li v-for="physician in $store.state.mel1Physicians" :key="physician.id" :class="{ active : physician.active }" @click="$store.commit('selectMel1ReferringPhysician', physician)">
							<div class="details">
								<div class="billing_item--code"><span class="name--first">{{ Physicians.methods.getPhysician(physician.id).firstName }}</span> {{ Physicians.methods.getPhysician(physician.id).lastName }}</div>
								<div class="billing_item--description">{{ physician.id }}</div>
							</div>
						</li>
					</ul>

					<button class="show_optional_fields" @click="mel1OptionalFields = !mel1OptionalFields">Enter optional info</button>
					
					<section class="optional_fields" v-if="mel1OptionalFields">
						<div class="title">
							<h5><!-- Start and end times --></h5>
						</div>
						<ul class="set_time">
							<li class="set_time--start">
								<button>
									<div>Start time</div>
									<div class="time start_time">:<!-- 13:45 --></div>
								</button>
							</li>
							<!-- <li class="set_time--divider">→</li> -->
							<li class="set_time--end">
								<button>
									<div>End time</div>
									<div class="time end_time">:<!-- 14:15 --></div>
								</button>
							</li>
						</ul>
	
						<div class="title title--condensed title--checkbox">
							<h5>Continuing care</h5>
							<!-- <ElementSwitch class="smallElementSwitch"></ElementSwitch> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Call out</h5>
							<!-- <ElementSwitch class="smallElementSwitch"></ElementSwitch> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Rural location</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Dependent billing</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>ICBC</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>WSBC</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Payment number</h5>
						</div>
	
						<div class="title title--condensed">
							<h5>Notes</h5>
						</div>
						<textarea class="input_notes" rows="4" placeholder="Notes are not private and are sent with the claim to MSP."></textarea>
					</section>

					<transition name="calculation_modal_fade">
						<div class="button--wrapper--modal" v-if="mel1ShowAmountCalculation" @click="mel1ShowAmountCalculation = false"></div>
					</transition>

					<div class="button--wrapper--combined" :class="{ active : mel1ShowAmountCalculation }">
						<header>
							<h2>Calculation</h2>	
						</header>

						<ul class="calculation_steps">
							<li>
								<div class="calculation_steps--name">
									Total value of billing items
								</div>
								<div class="calculation_steps--amount" style="color: #999">$87.79</div>
							</li>

							<!-- <li class="calculation_steps--divider">↓</li> -->

							<li>
								<div class="calculation_steps--name">
									<div class="calculation_steps--name--code">UGA</div>
									<div class="calculation_steps--name--description">Set base value to $98.76</div>
								</div>
								<div class="calculation_steps--amount" style="color: #999">$98.76</div>
							</li>

							<!-- <li class="calculation_steps--divider">↓</li> -->

							<li>
								<div class="calculation_steps--name">
									<div class="calculation_steps--name--code">BMIANT</div>
									<div class="calculation_steps--name--description">Increase by 25%</div>
								</div>
								<div class="calculation_steps--amount">$123.45</div>
							</li>
						</ul>
					</div>

					<div class="button--background">
						<div class="button--wrapper--combined--actions">
							<div class="calculation" @click="mel1ShowAmountCalculation = !mel1ShowAmountCalculation">
								<div class="price">$123.45</div>
								<p>View calculation</p>
							</div>
							<button class="primary mel1Primary"  @click="saveClaim(), $store.commit('navBarMinimised', false), $store.commit('navBarModalActive', false), mel1ShowAmountCalculation = false">Submit</button>
						</div>
					</div>

				</div>
			</ModalView>
		</transition>



		<!-- HOME DIALYSIS -->
    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="mel1">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="mel1 = false, $store.commit('navBarMinimised', false)"></button>
					<h2>Home dialysis</h2>
					<div>
						<button class="action_bar--text_action">Edit</button>
						<!-- <button class="action_bar--text_action" @click="mel1_showAll = !mel1_showAll">Expand</button> -->
					</div>
				</div>

				<div class="modalView--container template">
					<!-- <h1>Home dialysis</h1> -->

					<div style="height: 1.5rem" v-if="!mel1_showAll">
					</div>
					<div class="title" v-if="mel1_showAll">
						<h5>Date of service</h5>
					</div>

					<div class="date_slider--wrapper">
						<div class="date_slider--calendar" @click="launchDatePicker()"></div>
						<div class="date_slider">
							<div v-for="cell in $store.state.templateDates" class="date_slider--cell" :class="{ active : cell.active }" :key="cell.code" @click="$store.commit('selectDate', cell)">
								<div class="date_slider--cell--day">{{ cell.day }}</div>
								<div class="date_slider--cell--date">{{ cell.date }}</div>
							</div>
						</div>
					</div>

					<div class="title" v-if="mel1Patients_showAll">
						<h5>Patients</h5>
						<!-- <button class="button--text" v-if="$store.state.mel1Patients.length != 0">Compact</button> -->
					</div>

					<ul class="template--list template--list--remove active_patients">
						<li v-for="patient in $store.state.mel1Patients" :key="patient.id" :class="{ active : patient.active }" @click="$store.commit('mel1RemovePatientFromClaim', patient.id)">
							<div class="details">
								<div class="billing_item--code"><span class="name--first">{{ Patients.methods.getPatientObject(patient.id).firstName }}</span> {{ Patients.methods.getPatientObject(patient.id).lastName }}</div>
							</div>
						</li>

						<li v-for="group in $store.state.mel1Groups" :key="group.id" class="active active_group active_group--in_claim" @click="$store.commit('mel1RemoveGroupFromClaim', group.id)">
							<div class="details">
								<div class="billing_item--code"><span class="name--first">{{ Groups.methods.getGroupObject(group.id).name }}</span></div>
							</div>
							<div class="group_count">18</div>
						</li>
					</ul>

					<div class="patient--add_actions" v-if="$store.state.mel1Patients.length == 0">
						<button class="primary primary--patient_add" :disabled="$store.state.mel1Groups.length > 0">+ LabelSnap</button>
						<button class="primary primary--patient_add" :disabled="$store.state.mel1Groups.length > 0" @click="mel1PatientsSlideUp = true">+ Patient</button>
						<button class="primary primary--patient_add" :disabled="$store.state.mel1Groups.length > 0" @click="mel1GroupsSlideUp = true">+ Group</button>
					</div>

					<div class="patient--add_actions" v-if="$store.state.mel1Patients.length > 0">
						<button class="primary primary--patient_add">+ LabelSnap</button>
						<button class="primary primary--patient_add" @click="mel1PatientsSlideUp = true">+ Patient</button>
					</div>


					<div class="title">
						<h5>Billing details</h5>
					</div>

					<ul class="template--list billing_item template_combo">
						<li class="template_combo--billing_item">
							<div class="details">
								<div class="billing_item--code">33761</div>
								<div class="billing_item--description">Home dialysis</div>
							</div>
							<div class="amount">61.91</div>
						</li>
					</ul>

					<div class="template--list--wrapper">
						<div class="template--list--diagnosis_indicator">↳</div>
						<ul class="template--list diagnoses template_combo">
							<li class="active">
								<div class="billing_item--code">4340</div>
								<div class="billing_item--description">Chronic renal failure</div>
							</li>
						</ul>
					</div>

					<div class="title">
						<h5>Service location</h5>
						<button class="button--text" @click="mel1PhysiciansSlideUp = true">Other</button>
					</div>
					<ul class="template--list template--list--radio service_location">
						<li v-for="location in $store.state.mel1ServiceLocations" :key="location.code" :class="{ active : location.active }" v-show="location.templated || mel1_showAll || mel1ServiceLocation_showAll" @click="$store.commit('selectMel1ServiceLocation', location)">
							<div class="service_location--name">{{ location.name }}</div>
							<div class="service_location--code">{{ location.code }}</div>
						</li>
					</ul>


					<button class="show_optional_fields" @click="mel1OptionalFields = !mel1OptionalFields">Enter optional info</button>
					
					<section class="optional_fields" v-if="mel1OptionalFields">
						<div class="title">
							<h5><!-- Start and end times --></h5>
						</div>
						<ul class="set_time">
							<li class="set_time--start">
								<button>
									<div>Start time</div>
									<div class="time start_time">:<!-- 13:45 --></div>
								</button>
							</li>
							<!-- <li class="set_time--divider">→</li> -->
							<li class="set_time--end">
								<button>
									<div>End time</div>
									<div class="time end_time">:<!-- 14:15 --></div>
								</button>
							</li>
						</ul>
	
						<div class="title title--condensed title--checkbox">
							<h5>Referring physician</h5>
							<button class="button--text">Enable</button>
						</div>

						<div class="title title--condensed title--checkbox">
							<h5>Continuing care</h5>
							<!-- <ElementSwitch class="smallElementSwitch"></ElementSwitch> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Call out</h5>
							<!-- <ElementSwitch class="smallElementSwitch"></ElementSwitch> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Rural location</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Dependent billing</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>ICBC</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>WSBC</h5>
							<!-- <button class="button--text">Activate</button> -->
						</div>
	
						<div class="title title--condensed title--checkbox">
							<h5>Payment number</h5>
						</div>
	
						<div class="title title--condensed">
							<h5>Notes</h5>
						</div>
						<textarea class="input_notes" rows="4" placeholder="Notes are not private and are sent with the claim to MSP."></textarea>
					</section>

					<transition name="calculation_modal_fade">
						<div class="button--wrapper--modal" v-if="mel1ShowAmountCalculation" @click="mel1ShowAmountCalculation = false"></div>
					</transition>

					<div class="button--wrapper--combined" :class="{ active : mel1ShowAmountCalculation }">
						<header>
							<h2>Calculation</h2>	
						</header>

						<ul class="calculation_steps">
							<li>
								<div class="calculation_steps--name">
									Total value of billing items
								</div>
								<div class="calculation_steps--amount" style="color: #999">$87.79</div>
							</li>

							<!-- <li class="calculation_steps--divider">↓</li> -->

							<li>
								<div class="calculation_steps--name">
									<div class="calculation_steps--name--code">UGA</div>
									<div class="calculation_steps--name--description">Set base value to $98.76</div>
								</div>
								<div class="calculation_steps--amount" style="color: #999">$98.76</div>
							</li>

							<!-- <li class="calculation_steps--divider">↓</li> -->

							<li>
								<div class="calculation_steps--name">
									<div class="calculation_steps--name--code">BMIANT</div>
									<div class="calculation_steps--name--description">Increase by 25%</div>
								</div>
								<div class="calculation_steps--amount">$123.45</div>
							</li>
						</ul>
					</div>

					<div class="button--background">
						<div class="button--wrapper--combined--actions">
							<div class="calculation" @click="mel1ShowAmountCalculation = !mel1ShowAmountCalculation">
								<div class="price">$123.45</div>
								<p>View calculation</p>
							</div>
							<button class="primary mel1Primary"  @click="saveClaim(), $store.commit('navBarMinimised', false), mel1ShowAmountCalculation = false">Submit</button>
						</div>
					</div>

				</div>
			</ModalView>
		</transition>



		<!-- MEL 1 - BILLING ITEMS - SLIDE UP -->
		<ModalSlideUp :showComponents="mel1BillingItemsSlideUp" @updateStatus="mel1BillingItemsSlideUp = false">
			<div class="search_input--wrapper">
				<input class="search_input" placeholder="Search.." @focus="searchActive = true">
				<button class="search--close" @click="mel1BillingItemsSlideUp = false, slideUpBillingItems_tab1 = true, slideUpBillingItems_tab2 = false, slideUpBillingItems_tab3 = false">Close</button>
			</div>

			<div class="nav--claim">
				<button :class="{ active : slideUpBillingItems_tab1 }" @click="slideUpBillingItems_tab1 = true, slideUpBillingItems_tab2 = false, slideUpBillingItems_tab3 = false">Previously</button>
				<button :class="{ active : slideUpBillingItems_tab2 }" @click="slideUpBillingItems_tab1 = false, slideUpBillingItems_tab2 = true, slideUpBillingItems_tab3 = false">Nephrology</button>
				<button :class="{ active : slideUpBillingItems_tab3 }" @click="slideUpBillingItems_tab1 = false, slideUpBillingItems_tab2 = false, slideUpBillingItems_tab3 = true">All</button>
			</div>

			<div class="slideUpBillingItems_tab1_content" v-if="slideUpBillingItems_tab1">
				<ul class="template--list billing_item ">
					<li class="section_title">
						Last 3 months
					</li>

					<li v-for="item in $store.state.mel1BillingItemsSlideUpTab2" :key="item">
						<div class="details">
							<div class="billing_item--code">{{ item }}</div>
							<div class="billing_item--description">{{ BillingItems.methods.getBillingItemObject(item).name }}</div>
						</div>
						<div class="amount">{{ BillingItems.methods.getBillingItemObject(item).amount }}</div>
					</li>

				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="slideUpBillingItems_tab2">
				<ul class="template--list billing_item ">
					
					<li v-for="item in $store.state.mel1BillingItemsSlideUpTab2" :key="item">
						<div class="details">
							<div class="billing_item--code">{{ item }}</div>
							<div class="billing_item--description">{{ BillingItems.methods.getBillingItemObject(item).name }}</div>
						</div>
						<div class="amount">{{ BillingItems.methods.getBillingItemObject(item).amount }}</div>
					</li>
					
				</ul>
			</div>

			<div class="slideUpBillingItems_tab3_content" v-if="slideUpBillingItems_tab3">
				<ul class="template--list billing_item ">

					<li v-for="item in BillingItems.data.billingItems" :key="item.code">
						<div class="details">
							<div class="billing_item--code">{{ item.code }}</div>
							<div class="billing_item--description">{{ BillingItems.methods.getBillingItemObject(item.code).name }}</div>
						</div>
						<div class="amount">{{ BillingItems.methods.getBillingItemObject(item.code).amount }}</div>
					</li>

				</ul>
			</div>
    </ModalSlideUp>


    <!-- MEL 1 - DIAGNOSES - SLIDE UP -->
		<ModalSlideUp :showComponents="mel1DiagnosesSlideUp" @updateStatus="mel1DiagnosesSlideUp = false">
			<div class="search_input--wrapper">
				<input class="search_input" placeholder="Search.." @focus="searchActive = true">
				<button class="search--close" @click="mel1DiagnosesSlideUp = false, slideUpDiagnoses_tab1 = true, slideUpDiagnoses_tab2 = false, slideUpDiagnoses_tab3 = false">Close</button>
			</div>

			<div class="nav--claim">
				<button :class="{ active : slideUpDiagnoses_tab1 }" @click="slideUpDiagnoses_tab1 = true, slideUpDiagnoses_tab2 = false, slideUpDiagnoses_tab3 = false">Previously</button>
				<button :class="{ active : slideUpDiagnoses_tab2 }" @click="slideUpDiagnoses_tab1 = false, slideUpDiagnoses_tab2 = true, slideUpDiagnoses_tab3 = false">Nephrology</button>
				<button :class="{ active : slideUpDiagnoses_tab3 }" @click="slideUpDiagnoses_tab1 = false, slideUpDiagnoses_tab2 = false, slideUpDiagnoses_tab3 = true">All</button>
			</div>

			<div class="slideUpBillingItems_tab1_content" v-if="slideUpDiagnoses_tab1">
				<ul class="template--list diagnoses" style="width: 100%">
					<li class="section_title">
						Last 3 months
					</li>

					<li v-for="item in $store.state.mel1DiagnosesSlideUpTab2" :key="item">
						<div class="details">
							<div class="billing_item--code">{{ item }}</div>
							<div class="billing_item--description">{{ Diagnoses.methods.getDiagnosis(item).name }}</div>
						</div>
						<div class="amount">{{ Diagnoses.methods.getDiagnosis(item).amount }}</div>
					</li>

				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="slideUpDiagnoses_tab2">
				<ul class="template--list diagnoses" style="width: 100%">
					
					<li v-for="item in $store.state.mel1DiagnosesSlideUpTab2" :key="item">
						<div class="details">
							<div class="billing_item--code">{{ item }}</div>
							<div class="billing_item--description">{{ Diagnoses.methods.getDiagnosis(item).name }}</div>
						</div>
						<div class="amount">{{ Diagnoses.methods.getDiagnosis(item).amount }}</div>
					</li>
					
				</ul>
			</div>

			<div class="slideUpBillingItems_tab3_content" v-if="slideUpDiagnoses_tab3">
				<ul class="template--list diagnoses" style="width: 100%">

					<li v-for="item in Diagnoses.data.diagnoses" :key="item.code">
						<div class="details">
							<div class="billing_item--code">{{ item.code }}</div>
							<div class="billing_item--description">{{ Diagnoses.methods.getDiagnosis(item.code).name }}</div>
						</div>
						<div class="amount">{{ Diagnoses.methods.getDiagnosis(item.code).amount }}</div>
					</li>

				</ul>
			</div>
    </ModalSlideUp>



    <!-- MEL 1 - REFERRING PHYSICIANS - SLIDE UP -->
		<ModalSlideUp :showComponents="mel1PhysiciansSlideUp" @updateStatus="mel1PhysiciansSlideUp = false">
			<div class="search_input--wrapper">
				<input class="search_input" placeholder="Search.." @focus="searchActive = true">
				<button class="search--close" @click="mel1PhysiciansSlideUp = false, mel1SlideUpPhysicians_tab1 = true, mel1SlideUpPhysicians_tab2 = false, mel1SlideUpPhysicians_tab3 = false">Close</button>
			</div>

			<div class="nav--claim">
				<button :class="{ active : mel1SlideUpPhysicians_tab1 }" @click="mel1SlideUpPhysicians_tab1 = true, mel1SlideUpPhysicians_tab2 = false, mel1SlideUpPhysicians_tab3 = false">Previously</button>
				<button :class="{ active : mel1SlideUpPhysicians_tab2 }" @click="mel1SlideUpPhysicians_tab1 = false, mel1SlideUpPhysicians_tab2 = true, mel1SlideUpPhysicians_tab3 = false">All</button>
			</div>

			<div class="slideUpBillingItems_tab1_content" v-if="mel1SlideUpPhysicians_tab1">
				<ul class="template--list billing_item template--list--physicians">
					<li class="section_title">
						Last month
					</li>

					<li v-for="physician in Physicians.data.physicians" :key="physician.id">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ physician.firstName }}</span> {{ physician.lastName }}</div>
							<div class="billing_item--description">{{ physician.id }}</div>
						</div>
					</li>
					
				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="mel1SlideUpPhysicians_tab2">
				<ul class="template--list billing_item template--list--physicians">
					
					<li v-for="physician in Physicians.data.physicians" :key="physician.id">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ physician.firstName }}</span> {{ physician.lastName }}</div>
							<div class="billing_item--description">{{ physician.id }}</div>
						</div>
					</li>

				</ul>
			</div>
    </ModalSlideUp>


    <!-- MEL 1 - PATIENTS - SLIDE UP -->
		<ModalSlideUp :showComponents="mel1PatientsSlideUp" @updateStatus="mel1PatientsSlideUp = false">
			<div class="search_input--wrapper">
				<input class="search_input" placeholder="Search.." @focus="searchActive = true">
				<button class="search--close" @click="mel1PatientsSlideUp = false, mel1PatientsSlideUp_tab1 = true, mel1SlideUpPhysicians_tab2 = false, mel1SlideUpPhysicians_tab3 = false">Close</button>
			</div>

			<div class="nav--claim">
				<button :class="{ active : mel1PatientsSlideUp_tab1 }" @click="mel1PatientsSlideUp_tab1 = true, mel1PatientsSlideUp_tab2 = false, mel1PatientsSlideUp_tab3 = false">Last month</button>
				<button :class="{ active : mel1PatientsSlideUp_tab2 }" @click="mel1PatientsSlideUp_tab1 = false, mel1PatientsSlideUp_tab2 = true, mel1PatientsSlideUp_tab3 = false">Last 3 months</button>
				<button :class="{ active : mel1PatientsSlideUp_tab3 }" @click="mel1PatientsSlideUp_tab1 = false, mel1PatientsSlideUp_tab2 = false, mel1PatientsSlideUp_tab3 = true">All</button>
			</div>

			<div class="slideUpBillingItems_tab1_content" v-if="mel1PatientsSlideUp_tab1">
				<ul class="template--list billing_item template--list--physicians">
					<!-- <li class="section_title">
						Last month
					</li> -->

					<li v-for="patient in filteredPatients" :key="patient.id" @click="mel1AddPatientToClaim(patient.id)" :class="{ active : isPatientInListActiveInClaim(patient.id) }">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ patient.firstName }}</span> {{ patient.lastName }}</div>
							<div class="billing_item--description">{{ patient.phn }}</div>
						</div>
					</li>
					
				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="mel1PatientsSlideUp_tab2">
				<ul class="template--list billing_item template--list--physicians">
					
					<li v-for="patient in filteredPatients" :key="patient.id" @click="mel1AddPatientToClaim(patient.id)" :class="{ active : isPatientInListActiveInClaim(patient.id) }">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ patient.firstName }}</span> {{ patient.lastName }}</div>
							<div class="billing_item--description">{{ patient.phn }}</div>
						</div>
					</li>

				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="mel1PatientsSlideUp_tab3">
				<ul class="template--list billing_item template--list--physicians">
					
					<li v-for="patient in filteredPatients" :key="patient.id" @click="mel1AddPatientToClaim(patient.id)" :class="{ active : isPatientInListActiveInClaim(patient.id) }">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ patient.firstName }}</span> {{ patient.lastName }}</div>
							<div class="billing_item--description">{{ patient.phn }}</div>
						</div>
					</li>

				</ul>
			</div>
    </ModalSlideUp>


    <!-- MEL 1 - GROUPS - SLIDE UP -->
		<ModalSlideUp :showComponents="mel1GroupsSlideUp" @updateStatus="mel1GroupsSlideUp = false">
			<div class="search_input--wrapper">
				<input class="search_input" placeholder="Search.." @focus="searchActive = true">
				<button class="search--close" @click="mel1GroupsSlideUp = false, mel1GroupsSlideUp_tab1 = true, mel1GroupsSlideUp_tab2 = false, mel1GroupsSlideUp_tab3 = false">Close</button>
			</div>

			<div class="nav--claim">
				<button :class="{ active : mel1GroupsSlideUp_tab1 }" @click="mel1GroupsSlideUp_tab1 = true, mel1GroupsSlideUp_tab2 = false, mel1GroupsSlideUp_tab3 = false">Last month</button>
				<button :class="{ active : mel1GroupsSlideUp_tab2 }" @click="mel1GroupsSlideUp_tab1 = false, mel1GroupsSlideUp_tab2 = true, mel1GroupsSlideUp_tab3 = false">All</button>
			</div>

			<div class="slideUpBillingItems_tab1_content" v-if="mel1GroupsSlideUp_tab1">
				<ul class="template--list billing_item template--list--physicians">

					<li v-for="group in filteredGroups" :key="group.id" @click="mel1AddGroupToClaim(group.id), mel1GroupsSlideUp = false, mel1GroupsSlideUp_tab1 = true, mel1GroupsSlideUp_tab2 = false, mel1GroupsSlideUp_tab3 = false" class="active_group" :class="{ active : isGroupInListActiveInClaim(group.id) }">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ group.name }}</span></div>
						</div>
						<div class="group_count">18</div>
					</li>
					
				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="mel1GroupsSlideUp_tab2">
				<ul class="template--list billing_item template--list--physicians">
					
					<li v-for="group in filteredGroups" :key="group.id" @click="mel1AddGroupToClaim(group.id), mel1GroupsSlideUp = false, mel1GroupsSlideUp_tab1 = true, mel1GroupsSlideUp_tab2 = false, mel1GroupsSlideUp_tab3 = false" class="active_group" :class="{ active : isGroupInListActiveInClaim(group.id) }">
						<div class="details">
							<div class="billing_item--code"><span class="name--first">{{ group.name }}</span></div>
						</div>
						<div class="group_count">18</div>
					</li>

				</ul>
			</div>

    </ModalSlideUp>


    <!-- OBS1 - HOSPITAL BIRTH -->
    <transition name="modalView_pushLeft">
			<ModalView :modalZIndex="1030" v-if="obs1">
				<div class="action_bar">
					<button class="icon48 action_bar--icon--back" @click="obs1 = false, $store.commit('navBarModalActive', false)"></button>
					<!-- <button class="action_bar--text_action" @click="obs1_showAll = !obs1_showAll">Expand</button> -->
				</div>

				<div class="modalView--container template">
					<h1>Hospital birth</h1>
					
					<div class="title" v-if="obs1_showAll">
						<h5>Date of service</h5>
					</div>
					<div class="date_slider--wrapper">
						<div class="date_slider--calendar" @click="launchDatePicker()"></div>
						<div class="date_slider">
							<div v-for="cell in $store.state.templateDates" class="date_slider--cell" :class="{ active : cell.active }" :key="cell.date">
								<div class="date_slider--cell--day">{{ cell.day }}</div>
								<div class="date_slider--cell--date">{{ cell.date }}</div>
							</div>
						</div>
					</div>

					<ul class="template--list billing_item template_combo">
						<li class="template_combo--billing_item">
							<div class="details">
								<div class="billing_item--code">04008</div>
								<div class="billing_item--description">Visit - Hospital - OB&G</div>
							</div>
							<div class="amount">48.12</div>
						</li>
					</ul>

					<div class="template--list--wrapper">
						<div class="template--list--diagnosis_indicator">↳</div>
						<ul class="template--list diagnoses template_combo">
							<li class="active">
								<div class="billing_item--code">642</div>
								<div class="billing_item--description">Hypertension complicating pregnancy</div>
							</li>
						</ul>
					</div>

					<div class="template--list--wrapper">
						<div class="template--list--diagnosis_indicator">↳</div>
						<ul class="template--list diagnoses template_combo">
							<li class="active">
								<div class="billing_item--code">6510</div>
								<div class="billing_item--description">Twin pregnancy</div>
							</li>
						</ul>
					</div>

					<div class="title">
						<h5>Service location</h5>
						<button class="button--text" @click="obs1ServiceLocation_showAll = !obs1ServiceLocation_showAll" v-if="!obs1ServiceLocation_showAll">More</button>
						<button class="button--text" @click="obs1ServiceLocation_showAll = !obs1ServiceLocation_showAll" v-if="obs1ServiceLocation_showAll">Less</button>
					</div>
					<ul class="template--list service_location">
						<li class="active">
							<div class="service_location--name">Hospital inpatient</div>
							<div class="service_location--code">I</div>
						</li>
						<li v-if="obs1_showAll || obs1ServiceLocation_showAll">
							<div class="service_location--name">Hospital outpatient</div>
							<div class="service_location--code">P</div>
						</li>
						<li v-if="obs1_showAll || obs1ServiceLocation_showAll">
							<div class="service_location--name">Practitioner's office, in publically administered facility</div>
							<div class="service_location--code">T</div>
						</li>
						<li v-if="obs1_showAll || obs1ServiceLocation_showAll">
							<div class="service_location--name">Patient's private home</div>
							<div class="service_location--code">R</div>
						</li>
						<li v-if="obs1_showAll || obs1ServiceLocation_showAll">
							<div class="service_location--name">Practitioner's office, in community</div>
							<div class="service_location--code">A</div>
						</li>
						<li class="other" v-if="obs1_showAll || obs1ServiceLocation_showAll">
							Select other
						</li>
					</ul>

					<div class="title">
						<h5>Referring physicians</h5>
						<button class="button--text" @click="obs1ReferringPhysician_showAll = !obs1ReferringPhysician_showAll" v-if="!obs1ReferringPhysician_showAll">More</button>
						<button class="button--text" @click="obs1ReferringPhysician_showAll = !obs1ReferringPhysician_showAll" v-if="obs1ReferringPhysician_showAll">Less</button>
					</div>
					<ul class="template--list template--list--radio referring_physicians">
						<li class="active">
							<div class="physician--name">Nicola Aaronson</div>
							<div class="physician--number">86687</div>
						</li>
						<li>
							<div class="physician--name">Michael Ayotunde Abayomi</div>
							<div class="physician--number">68611</div>
						</li>
						<li class="other" v-if="obs1_showAll || obs1ReferringPhysician_showAll">
							Other
						</li>
					</ul>

					<div class="button--wrapper">
						<button class="primary" @click="saveClaim(), $store.commit('navBarModalActive', false)">Submit</button>
					</div>
				</div>
			</ModalView>
		</transition>


		<!-- OBS 1 - BILLING ITEMS - SLIDE UP -->
		<ModalSlideUp :showComponents="obs1SlideUp" @updateStatus="obs1SlideUp = false">
			<div class="search_input--wrapper">
				<input class="search_input" placeholder="Search.." @focus="searchActive = true">
				<button class="search--close" @click="obs1SlideUp = false, slideUpBillingItems_tab1 = true, slideUpBillingItems_tab2 = false, slideUpBillingItems_tab3 = false">Close</button>
			</div>

			<div class="nav--claim">
				<button :class="{ active : slideUpBillingItems_tab1 }" @click="slideUpBillingItems_tab1 = true, slideUpBillingItems_tab2 = false, slideUpBillingItems_tab3 = false">Previously</button>
				<button :class="{ active : slideUpBillingItems_tab2 }" @click="slideUpBillingItems_tab1 = false, slideUpBillingItems_tab2 = true, slideUpBillingItems_tab3 = false">Obstetrics</button>
				<button :class="{ active : slideUpBillingItems_tab3 }" @click="slideUpBillingItems_tab1 = false, slideUpBillingItems_tab2 = false, slideUpBillingItems_tab3 = true">All</button>
			</div>

			<div class="slideUpBillingItems_tab1_content" v-if="slideUpBillingItems_tab1">
				<ul class="template--list billing_item ">
					<!-- <li class="section_title">
						Previously used
					</li> -->
					<li>
						<div class="details">
							<div class="billing_item--code">33706</div>
							<div class="billing_item--description">Directive care - Nephrology</div>
						</div>
						<div class="amount">43.60</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33706</div>
							<div class="billing_item--description">Directive care - Nephrology</div>
						</div>
						<div class="amount">43.60</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33706</div>
							<div class="billing_item--description">Directive care - Nephrology</div>
						</div>
						<div class="amount">43.60</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33706</div>
							<div class="billing_item--description">Directive care - Nephrology</div>
						</div>
						<div class="amount">43.60</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33706</div>
							<div class="billing_item--description">Directive care - Nephrology</div>
						</div>
						<div class="amount">43.60</div>
					</li>
				</ul>
			</div>

			<div class="slideUpBillingItems_tab2_content" v-if="slideUpBillingItems_tab2">
				<ul class="template--list billing_item ">
					<!-- <li class="section_title">
						Previously used
					</li> -->
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33710</div>
							<div class="billing_item--description">Consultation - Nephrology</div>
						</div>
						<div class="amount">160.47</div>
					</li>
				</ul>
			</div>

			<div class="slideUpBillingItems_tab3_content" v-if="slideUpBillingItems_tab3">
				<ul class="template--list billing_item ">
					<!-- <li class="section_title">
						Previously used
					</li> -->
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
					<li>
						<div class="details">
							<div class="billing_item--code">33761</div>
							<div class="billing_item--description">Home dialysis</div>
						</div>
						<div class="amount">61.91</div>
					</li>
				</ul>
			</div>
    </ModalSlideUp>




  </div>
</template>


<script>
import Patients from '@/stores/PatientsStore.js'
import Groups from '@/stores/PatientGroupStore.js'
import BillingItems from '@/stores/BillingItemsStore.js'
import Diagnoses from '@/stores/DiagnosesStore.js'
import Physicians from '@/stores/PhysicianStore.js'
import ModalView from '@/components/ModalView.vue'
import ModalSlideUp from '@/components/ModalSlideUp.vue'
// import ElementSwitch from '@/components/ElementSwitch.vue'

export default {
  name: 'S3',
  components: {
    ModalView,
    ModalSlideUp,
    // ElementSwitch,
  },
  data: function () {
    return {
			Patients: Patients,
			Groups: Groups,
			BillingItems: BillingItems,
			Diagnoses: Diagnoses,
			Physicians: Physicians,
			modalHasLaunched: false,
			diagnosis1: false,
			diagnosis2: false,
			diagnosis3: false,
			diagnosis4: false,
			diagnosis5: false,
			diagnosis6: false,
			diagnosisDescriptionSwitchStatus: false,
			billingCombo1: false,
			billingCombo2: false,
			billingCombo3: false,
			viewToast: false,
			viewTemplate1: false,
			viewTemplate2: false,
			viewTemplate3: false,
			viewTemplateList: false,
			templateListActive: false,
			viewClaim: false,
			viewLabelSnap: false,
			labelSnapTaken: false,
			labelSnapStandalone: false,
			labelSnapTemplate1: false,
			labelSnapTemplate2: false,
			workspaceActive: false,
			workspaceActiveExpanded: false,
			slideUpTemplate1: false,
			viewEditTemplates: false,
			viewAddTemplate: false,
			viewEditTemplate1: false,
			viewEditTemplate2: false,
			viewEditTemplate3: false,
			viewEditTemplate4: false,
			templatesTab1Active: true,
			templatesTab2Active: false,
			templatesTab3Active: false,
			actionMenu: false,
			mel1: false,
			mel2: false,
			mel1_showAll: false,
			mel1Patients_showAll: true,
			mel1BillingItem_showAll: false,
			mel1Diagnoses_showAll: false,
			mel1ServiceLocation_showAll: false,
			mel1ReferringPhysician_showAll: false,
			mel1BillingItemsSlideUp: false,
			mel1PatientsSlideUp: false,
			mel1DiagnosesSlideUp: false,
			mel1PhysiciansSlideUp: false,
			mel1OptionalFields: false,
			mel1ShowAmountCalculation: false,
			mel1PatientsSlideUp_tab1: true,
			mel1PatientsSlideUp_tab2: false,
			mel1PatientsSlideUp_tab3: false,
			mel1GroupsSlideUp: false,
			mel1GroupsSlideUp_tab1: true,
			mel1GroupsSlideUp_tab2: false,
			mel1GroupsSlideUp_tab3: false,
			slideUpBillingItems_tab1: true,
			slideUpBillingItems_tab2: false,
			slideUpBillingItems_tab3: false,
			slideUpDiagnoses_tab1: true,
			slideUpDiagnoses_tab2: false,
			slideUpDiagnoses_tab3: false,
			mel1SlideUpPhysicians_tab1: true,
			mel1SlideUpPhysicians_tab2: false,
			mel1SlideUpPhysicians_tab3: false,
			mel1ContinuingCare: false,
			mel1CallOut: false,
			mel1RuralLocation: false,
			mel1DependentBilling: false,
			mel1ICBC: false,
			mel1WSBC: false,
			mel1PaymentNumber: false,
			obs1: false,
			obs1_showAll: false,
			obs1BillingItem_showAll: false,
			obs1Diagnoses_showAll: false,
			obs1ServiceLocation_showAll: false,
			obs1ReferringPhysician_showAll: false,
			obs1SlideUp: false,
    }
  },
  methods: {
		viewTemplate1Active($state) {
			this.viewToast = false;
			this.viewTemplate1 = $state;
			this.$store.commit('navBarModalActive', true);
		},
		viewTemplate2Active($state) {
			this.viewToast = false;
			this.viewTemplate2 = $state;
			this.$store.commit('navBarModalActive', true);
		},
		viewTemplate3Active($state) {
			this.viewToast = false;
			this.viewTemplate3 = $state;
			this.$store.commit('navBarModalActive', true);
		},
		viewTemplateListActive($state) {
			this.viewToast = false;
			this.viewTemplateList = $state;
		},
		showTemplateList() {
			// console.log('asasas');
		},
		viewClaimActive($state) {
			this.viewClaim = $state;
		},
		getLastUsedDate() {
			var $date = this.$store.state.lastUsedDate;

			if ( $date == 'Today') {
        return $date;
      } else {
        return $date.substring(0, $date.length - 5);
      }
		},
		formatDate($date) {
      if ( $date == 'Today') {
        return $date;
      } else {
        return $date.substring(0, $date.length - 5);
      }
    },
    showCamera($state) {
			this.viewLabelSnap = $state;
			setTimeout(this.updateNavBarState, 300);
    },
    updateNavBarState() {
			this.$store.commit('navBarModalActive', false);
    },
		takeLabelSnap($type) {
			if ( $type == 'inClaim' ) {
				this.viewLabelSnap = true;
			} else if ( $type == 'standalone' ) {
				this.viewLabelSnap = true;
				this.labelSnapStandalone = true;
			}
		},
		useTemplateFromLabelSnap() {
			this.templateListActive = true;
		},
		addToWorkspace() {
			alert('addToWorkspace');
		},
		minimiseWorkspace() {
			this.workspaceActiveExpanded = false;
			this.$store.commit('navBarMinimised', false);
		},
		saveClaim() {
			//this.$store.commit('navBarModalActive', false);
			this.$store.state.mel1Patients = [];
			this.$store.state.mel1Groups = [];
			this.labelSnapTaken = false;
			this.viewLabelSnap = false;
			this.viewTemplate1Active(false);
			this.viewTemplate2Active(false);
			this.viewTemplate3Active(false);
			this.diagnosis1 = false,
			this.diagnosis2 = false,
			this.diagnosis3 = false,
			this.diagnosis4 = false,
			this.diagnosis5 = false,
			this.diagnosis6 = false,
			this.billingCombo1 = false,
			this.billingCombo2 = false,
			this.billingCombo3 = false,
			this.viewToast = true;
			this.mel1 = false;
			this.mel2 = false;
			this.obs1 = false;
		},
		setDiagnosisDescriptionSwitchStatus($state) {
			this.diagnosisDescriptionSwitchStatus = $state;
		},
		selectBillingCombo($comboNumber) {
			var $i = 1;
			while ( $i < 99 ) {
				if ( typeof this["billingCombo" + $comboNumber] == 'undefined') {
					break;
				} else {
					this["billingCombo" + $i] = false;
					$i++;
				}
			}

			this["billingCombo" + $comboNumber] = true;
		},
		swTest() {
			alert("SW Test");
		},
		templatesTab1() {
			if ( this.templatesTab1Active == false ) {
				this.templatesTab1Active = true;
				this.templatesTab2Active = false;
				this.templatesTab3Active = false;
			}
		},
		templatesTab2() {
			if ( this.templatesTab2Active == false ) {
				this.templatesTab1Active = false;
				this.templatesTab2Active = true;
				this.templatesTab3Active = false;
			}
		},
		templatesTab3() {
			if ( this.templatesTab3Active == false ) {
				this.templatesTab1Active = false;
				this.templatesTab2Active = false;
				this.templatesTab3Active = true;
			}
		},
		launchDatePicker() {
			alert('Lauch date picker popup');
		},
		mel1AddPatientToClaim($id) {
			if ( this.claimPatientIdArray.includes($id) ) {
				this.$store.commit('mel1RemovePatientFromClaim', $id);
			} else {
				this.$store.commit('mel1AddPatientToClaim', $id);	
			}
		},
		isPatientInListActiveInClaim($id) {
			if ( this.claimPatientIdArray.includes($id) ) {
				return true;
			} else {
				return false;
			}
		},
		mel1AddGroupToClaim($id) {
			if ( this.claimGroupIdArray.includes($id) ) {
				this.$store.commit('mel1RemoveGroupFromClaim', $id);
			} else {
				this.$store.commit('mel1AddGroupToClaim', $id);	
			}
		},
		isGroupInListActiveInClaim($id) {
			if ( this.claimGroupIdArray.includes($id) ) {
				return true;
			} else {
				return false;
			}
		},
  },
  computed: {
		claimPatientIdArray() {
			var array = this.$store.state.mel1Patients;
			var idArray = array.map(x => x.id);

			return idArray;
		},
		claimGroupIdArray() {
			var array = this.$store.state.mel1Groups;
			var idArray = array.map(x => x.id);

			return idArray;
		},
		filteredPatients() {
      var filteredArray = this.Patients.data.patients;
      
      // var filteredArray = this.Patients.data.patients.filter(item => 
      //   item.filterStatus == true
      // );

      // filteredArray = filteredArray.filter(item => 
      //   item.firstName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      //   item.lastName.toLowerCase().includes(this.searchTerm.toLowerCase())
      // );

      return filteredArray.sort((a, b) => a.lastName.localeCompare(b.lastName));
    },
    filteredGroups() {
			var filteredArray = this.Groups.data.groups;
			return filteredArray.sort((a, b) => a.lastName.localeCompare(b.lastName));
    },
    isLastUsedDateSetToToday() {
			if ( this.$store.state.lastUsedDate == 'Today' ) {
				return true;
			} else {
				return false;
			}
		}
  }
}	
</script>


<style scoped>
.create {
	/*bottom: env(safe-area-inset-bottom);*/
	bottom: 0;
	left: 0;
	position: fixed;
	right: 0;
	/*top: env(safe-area-inset-top);*/
	top: 0;
}


.toast--wrapper {
	display: inline-block;
	left: 50%;
	position: absolute;
	top: calc(1rem + env(safe-area-inset-top));
	transform: translateX(-50%);
}
.toast {
	align-items: center;
	background-color: #FFF176;
	border-radius: 8px;
	display: flex;
	font-weight: 500;
	height: 32px;
	justify-content: center;
	opacity: 0;
	padding-left: 1rem;
	padding-right: 1rem;
	text-align: center;
	width: auto;
}
.toast_pushDown-enter-active, .toast_pushDown-leave-active {
  transition: transform 0.3s ease 0.3s, opacity 1.5s ease 2s;
}
.toast_pushDown-enter, .toast_pushDown-leave-to {
	opacity: 1;
  transform: translateY(-200%);
}



main {
	/*height: 100vh;*/
	padding: 0 1rem 1rem;
	/*position: relative;*/
}
h1 {
	font-weight: 700;
	margin-bottom: 0.5rem;
}
h2 {
	margin-bottom: 1rem;
}
h3 {
	font-size: 15px;
	font-weight: 500;
	letter-spacing: 0.5px;
	text-transform: uppercase;
}
h5 {
	margin-bottom: 0.25rem;
}
.minor {
	
}


.group {
	margin-bottom: 1rem;
	/*margin-top: 1rem;*/
}
.title--wrapper {
	display: flex;
	justify-content: space-between;
}


.template_1 .group {
	margin-bottom: 0;
	margin-top: 0;
}
.inline_control,
.inline_control h5 {
	margin-bottom: 0;
}
.inline_control .title--wrapper {
	align-items: center;
}



.permanent {
	margin-bottom: 2.5rem;
	width: 100%;
}
.permanent ul {
	border: none;
	display: flex;
}
.permanent ul li {
	border: none;
	width: calc(100% / 3);
}
.permanent ul li + li {
	margin-left: 0.5rem;
}
.permanent button.list_item {
	align-items: center;
	background-color: var(--light-blue);
	border-radius: 8px;
	color: var(--blue);
	display: flex;
	font-size: 16px;
	height: 40px;
	justify-content: center;
	text-align: center;
}
.permanent button.list_item .icon {
	height: 24px;
	margin-right: 0.25rem;
	width: 24px;
}


.title_block {
	align-items: center;
	display: flex;
	justify-content: space-between;
}
.title_block button.edit_templates {
	/*background: url('/img/icon--add--empty.svg') no-repeat center center;*/
	border: 1.5px solid var(--blue);
	border-radius: 2px;
	color: var(--blue);
	font-size: 13px;
	font-weight: 600;
	height: 28px;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
	text-transform: uppercase;
	width: 48px;
}

.icon--claim {
	background: url('/img/icon--claim.svg') no-repeat center center;
}
.icon--patient {
	background: url('/img/icon--patient.svg') no-repeat center center;
}
.icon--group {
	background: url('/img/icon--group.svg') no-repeat center center;
}
.icon--labelsnap {
	background: url('/img/icon--take_labelsnap.svg') no-repeat center center;
	margin-right: 0.5rem;
}


.templates {
	margin-top: 2rem;
}
.templates li {
	padding-bottom: 0.375rem;
	padding-top: 0.375rem;
}
.templates li button.list_item {
	height: auto;
	min-height: 36px;
}
.template_list_item--name {
	font-weight: 600;
}
.template_list_item--summary {
	color: #999;
	display: flex;
	font-size: 14px;
	font-weight: 500;
	justify-content: flex-start;
	margin-top: 0.25rem;
}
.template_list_item--summary .billing_item {
	/*background-color: #eee;*/
	border: 1px solid #ccc;
	border-radius: 3px;
	margin-right: 0.25rem;
	padding-left: 0.375rem;
	padding-right: 0.375rem;
}
.template_list_item--summary .diagnosis {
	/*background-color: #eee;*/
	border: 1px solid #ccc;
	border-radius: 3px;
	margin-right: 0.25rem;
	padding-left: 0.375rem;
	padding-right: 0.375rem;
}
.template_list_item--summary .separator {
	color: #aaa;
	margin-right: 0.25rem;
}



button.list_item {
	font-size: 18px;
	font-weight: 500;
	height: 48px;
	line-height: 1.25em;
	padding-left: 0;
	text-align: left;
	width: 100%;
}
button.list_item.checkbox {
	background: url('/img/icon--check--empty.svg') no-repeat left center;
	height: auto;
	padding-left: 32px;
}
button.list_item.checkbox.active {
	background: url('/img/icon--check--selected.svg') no-repeat left center;
}
button.list_item.radio {
	background: url('/img/icon--check--empty.svg') no-repeat left center;
	height: auto;
	padding-left: 32px;
}
button.list_item.radio.active {
	background: url('/img/icon--radio--selected.svg') no-repeat left center;
}


.patient--add_actions {
	display: flex;
}
.patient--add_actions button:disabled {
	background-color: transparent;
	color: #999;
}

button.primary--patient_add {
	align-items: center;
	/*background-color: var(--light_blue);*/
	/*border: 2px solid var(--light-blue);*/
	display: flex;
	font-size: 15px;
	height: 48px	;
	justify-content: center;
	width: calc(100% / 3);
}
button.primary--patient_add:first-of-type {
	border-radius: 8px 0 0 8px;
}
button.primary--patient_add:nth-of-type(2) {
	border-left: 2px solid #fff;
	border-radius: 0;
}
button.primary--patient_add:last-of-type {
	border-left: 2px solid #fff;
	border-radius: 0 8px 8px 0;
}
/*button.primary--patient_add div {
	align-items: center;
	display: flex;
	font-size: 15px;
	height: 48px	;
	justify-content: center;
	width: calc(100% / 3);
}
button.primary--patient_add div + div {
	border-left: 1px solid #fff;
}*/

button.diagnosis {
	min-height: 48px;
	padding-bottom: 0.5rem;
	padding-top: 0.5rem;
}
button.diagnosis .minor {
	color: #999;
	display: block;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.25em;
}


button.primary {
	align-items: center;
	border-radius: 4px;
	display: flex;
	height: 48px;
	justify-content: center;
	width: 100%;
}
button.primary.fixed {
	bottom: calc(1rem + env(safe-area-inset-bottom));
	position: absolute;
	width: calc(100% - 2rem);
}
button.primary.disabled {
	cursor: default;
	opacity: 0.4;
}
button.primary.active {
	opacity: 1;
}
button.secondary {
	color: #007AFF;
	height: 48px;
	width: 100%;
}
button.inlineButton {
	border: 1px solid #ccc;
	border-radius: 4px;
	color: #ccc;
	font-size: 15px;
	height: 32px;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
}

.date_picker {
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-right: -12px;
	width: 160px;
}
button.date_picker--previous {
	background: url('/img/icon--minus.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}
button.date_picker--next {
	background: url('/img/icon--add--active.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}
.date_picker button[disabled=disabled] {
	background: url('/img/icon--add--disabled.svg') no-repeat center center;
	opacity: 0.4;
}

button.button--action {
	color: #007AFF;
	font-size: 13px;
	font-weight: 600;
	text-transform: uppercase;
}



button.primary--labelsnap {
	border-radius: 0;
	bottom: calc(3rem + env(safe-area-inset-bottom));
	height: 56px;
	margin-left: -1rem;
	position: absolute;
	/*width: calc(100% - 2rem);*/
	width: 100%;
}

.smallElementSwitch {
	transform: scale(0.75);
	transform-origin: right;
}



/* TEMPLATE */
.summary {
	background-color: #eee;
	margin-left: -1rem;
	width: 100vw;
}
.table--summary {
	/*margin-bottom: 1rem;*/
	margin-left: 1rem;
}
.table--summary td {
	font-weight: 500;
}
.table--summary tr:first-of-type td {
	padding-top: 0.5rem;
}
.table--summary tr:last-of-type td {
	padding-bottom: 0.5rem;
}
.table--summary .title {
	color: #9b9b9b;
	font-size: 13px;
	padding-right: 1rem;
	text-transform: uppercase;
	white-space: nowrap;
}
.table--summary tr td:nth-of-type(2) {
	font-size: 16px;
	padding-right: 1rem;
	width: 100%;
}

.table--border--bottom td {
	border-bottom: 4px solid #fff;
	padding-bottom: 0.5rem;
}
.table--border--top td {
	border-top: 4px solid #fff;
	padding-top: 0.5rem;
}



/*LABELSNAP*/
.takeLabelSnap {
	border: 3px dashed #ccc;
	border-radius: 6px;
	height: 120px;
	margin-bottom: 4rem;
	width: 100%;
}
.takeLabelSnap button {
	color: #007AFF;
	height: 100%;
	width: 100%;
}
.takeLabelSnap.active {
	background: url('/img/index_card.jpg') no-repeat center center;
	background-size: cover;
	border: none;
	margin-bottom: 0;
}
.takeLabelSnap.active button {
	display: none;
}


button.add_to_workspace_once {
	border-radius: 8px 0 0 8px;
	display: inline-flex;
	margin-right: 2px;
	width: calc(100% - 50px)
}
button.add_to_workspace_another {
	border-radius: 0 8px 8px 0;
	background: #E5F1FF url('/img/icon--add--empty.svg') no-repeat center center;
	display: inline-flex;
	width: 48px;
}



/*TEMPLATE ELEMENTS*/
.diagnosis_cell {
	align-items: center;
	border: 1px solid #666;
	border-radius: 4px;
	display: inline-flex;
	margin-bottom: 0.5rem;
}
.diagnosis_cell div {
	align-items: center;
	display: flex;
	height: 30px;
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}
.diagnosis_cell div:nth-of-type(1) {

}
.diagnosis_cell div:nth-of-type(2) {
	background-color: #666;
	color: #fff;
	font-weight: 600;
}
.diagnosis_cell div span {
	color: #ccc;
	font-weight: 600;
	padding-left: 0.25rem;
	padding-right: 0.25rem;
}



/*TEMPLATE 2*/
.diagnoses_list.compact {
	display: flex;
	flex-wrap: wrap;
}
.diagnoses_list.compact li {
	border: none;
}
.diagnoses_list.compact li button {
	background: url('/img/icon--check--empty.svg') no-repeat 0.5rem center;
	border: 1px solid #ccc;
	border-radius: 4px;
	min-height: 40px;
	margin-right: 0.5rem;
	margin-top: 0.5rem;
	padding-left: 2.5rem;
	padding-right: 1rem;
	width: auto;
}
.diagnoses_list.compact li button.active {
	background: #f3f3f3 url('/img/icon--check--selected.svg') no-repeat 0.5rem center;
}


/*TEMPLATE 3*/
.template_3 li {
	border-bottom: none;
}
.template_3 .diagnosis_cell {
	margin-bottom: 0;
}


/*TEMPLATE LIST*/
.showTemplatesToApplyToLabelSnap .templates {
	margin-top: 0;
}


/*LABELSNAP*/
.dark {
  background-color: #000;
  /*transition: 1s all ease;*/
}


/*CAMERA*/
.camera .primary {
	margin-top: 0.5rem;
}
.camera--actions {
	align-items: center;
	display: flex;
	justify-content: center;
	left: 0;
	position: fixed;
	bottom: calc(3rem + env(safe-area-inset-bottom));
	width: 100%;
}
.action {
	text-align: center;
	width: 40%;
}
.shutter {
	background-color: var(--blue);
	border-radius: 32px;
	cursor: pointer;
	height: 64px;
	position: relative;
	width: 64px;
}
.shutter:before {
	bottom: 0.3rem;
	border: 4px solid #fff;
	border-radius: 32px;
	content: "";
	left: 0.3rem;
	position: absolute;
	right: 0.3rem;
	top: 0.3rem;
	z-index: 2;
}
.camera--window {
	background: url('/img/labelsnap-camera_active.jpg') no-repeat center center;
	background-size: cover;
	height: 160px;
	left: 0;
	position: absolute;
	top: calc(3rem + env(safe-area-inset-top));
	width: 100%;
}
.labelSnap_taken {
	background: url('/img/labelsnap_in_camera.jpg') no-repeat center center;
	background-size: cover
}
.camera--review {
	/*background: #000;*/
	bottom: 0;
	left: 0;
	padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom));
	position: absolute;
	/*transition: 1s bottom ease, 1s opacity ease;*/
	width: 100%;
}
.camera--review ul {
	margin-bottom: 2rem;
}
/*.camera--review button {
	background: pink;
	border-radius: 4px;
	height: 48px;
	margin-bottom: 0.5rem;
	width: 100%;
}*/
.camera .templates {
	bottom: calc(3rem + env(safe-area-inset-bottom));
	position: absolute;
	width: 100%;
}

.sample_labelsnap {
	margin-top: 12rem;
	text-align: center;
}
.sample_labelsnap p {
	color: #999;
	font-weight: 500;
	margin-bottom: 1rem;
}
.sample_labelsnap img {
	width: calc(100% - 2rem);
}



.templateListActive {
	background-color: #fff;
}
.templateListActive .labelSnap_taken {
/*	top: 3rem;*/
}
.templateListActive .camera--review {
	bottom: 3rem;
	opacity: 0;
}
.templateListActive .camera--shoot {
	display: none;
}
.dark .templates {
	bottom: 4rem;
	position: absolute;
	width: calc(100% - 2rem);
}



/*SLIDEUP - ACTION SHEET*/
.pull {
	background-color: #ccc;
	border-radius: 3px;
	height: 6px;
	left: calc(50% - 1.5rem);
	margin-top: 0.25rem;
	position: absolute;
	top: 0;
	width: 3rem;
}
.slideUp--action_sheet {

}
.slideUp--action_sheet button.primary {
	margin-top: 1rem;
}

.slide_up--actions {
	border-top: none;
	margin-top: 1rem;
}
.slide_up--actions h4 {
	color: #999;
	font-size: 15px;
	font-weight: 500;
	text-transform: uppercase;
}
.slide_up--actions h5 {
	color: #333;
	font-weight: 500;
}
.slide_up--actions .title--wrapper {
	/*align-items: center;*/
	height: 48px;
}
.slide_up--actions li {
	height: 48px;
	line-height: 48px;
}
.slide_up--actions li button {
	color: var(--blue);
	height: 48px;
}
.slide_up--actions--title {
	align-items: center;
	display: flex;
	height: 48px;
	justify-content: space-between;
}
.slide_up--actions--title .expand {
	border: 1px solid var(--blue);
	border-radius: 3px;
	font-size: 13px;
	height: auto;
	padding: 0.375rem 0.5rem;
	text-transform: uppercase;
}
button.slide_up_primary {
	margin-top: 2rem;
}

.slide_up--actions--template1 h5 {
	font-size: 14px;
	line-height: 1em;
	margin-top: 1rem;
	text-align: center;
	text-transform: uppercase;
}
.slide_up--actions--template1 .date_picker {
	font-size: 32px;
	height: auto;
	justify-content: center;
	width: 100%;
}
.slide_up--actions--template1 .date_picker--date {
	text-align: center;
	width: 100px;
}
.slide_up--actions--template1 button.date_picker--previous,
.slide_up--actions--template1 button.date_picker--next {
	background-size: 32px 32px;
	height: 48px;
	width: 48px;
}


/*WORKSPACE*/
.workspace {
	background-color: #fdfdfd;
	border: 1px solid #ccc;
	border-bottom: none;
	border-radius: 16px 16px 0 0;
	bottom: 0;
	/*height: 104px;*/
	left: -1px;
	padding-bottom: 4rem;
	position: absolute;
	transform: translateY(calc(100% - 56px - 48px - env(safe-area-inset-bottom)));
	transition: 0.5s all ease;
	width: calc(100% + 2px);
	z-index: 980;
}
.workspace h2 {
	font-size: 20px;
	line-height: 56px;
	margin-bottom: 0;
	padding-left: 16px;
}
.workspace h3 {
	background: #666;
	border-radius: 3px;
	color: #fff;
	display: block;
	font-size: 18px;
	font-weight: 600;
	line-height: 24px;
	margin-right: 1rem;
	text-align: center;
	width: 24px;
}
.workspace .title--wrapper {
	align-items: center;
	border-bottom: 0.5px solid #ccc;
	cursor: pointer;
}
.workspace .takeLabelSnap {
	margin-left: 1rem;
	margin-top: 1rem;
	width: calc(100% - 2rem);
}
.workspace.expand {
	transform: translateY(0);
}
.workspace.expand .title--wrapper {
	cursor: default;
}


/*TEMPLATE NAV*/
.modalView--templates {
	/*background-color: #F5F5F5;*/
	min-height: 100vh;
	padding-left: 0;
	padding-right: 0;
}
.modalView--templates h1 {
	padding-left: 1rem;
}
.nav--claim {
	background-color: #fff;
	border-bottom: 1px solid #eee;
	/*box-shadow: 0 6px 6px 0 #ddd;*/
	position: sticky;
	top: 0;
}
.nav--claim.search_active {
	position: static;
}
.nav--claim button {
	color: #999;
	font-size: 17px;
	font-weight: 700;
	height: 48px;
	margin-left: 1rem;
	margin-right: 1rem;
}
.nav--claim button.active {
	border-bottom: 4px solid #007AFF;
	color: #333;
}
.templates--installed {
	background-color: #F5F5F5;
	min-height: 100vh;
	padding-bottom: 1rem;
	padding-top: 1rem;
}
.templates--installed button {
	background: #fff url('/img/icon--chevron--right.svg') no-repeat right center;
	border-radius: 10px;
	margin-bottom: 0.5rem;
	margin-left: 1rem;
	padding: 1rem;
	text-align: left;
	width: calc(100% - 2rem);
}


button.action_bar--add {
	background: url('/img/icon--add--empty.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}


/*TEMPLATES - EDIT*/
.templates--edit h1 {
	margin-bottom: 1.5rem;
}
.templates--edit ul {
	border: none;
	padding-left: 1rem;
	padding-right: 1rem;
}
.templates--edit ul li:first-of-type {
	border-top: 0.5px solid #ccc;
}
.templates--edit ul li {
	align-items: center;
	display: flex;
	height: 48px;
	justify-content: space-between;
}
.templates--edit ul li button {
	height: 48px;
}
.templates--edit ul li button:first-of-type {
	text-align: left;
	width: calc(100% - 48px + 0.75rem);
}
button.rearrange {
	background: url('/img/icon--rearrange.svg') no-repeat center center;
	height: 48px;
	margin-right: -0.75rem;
	width: 48px;
}





/*MEL 1*/
.template {
	padding-bottom: calc(6rem + env(safe-area-inset-bottom));
}
.template h5 {
	color: #333;
}
.template .button--wrapper {
	background-color: #fff;
	/*border-top: 1px solid #ddd;*/
	bottom: 0;
	left: 0;
	/*padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom)) 1rem;*/
	/*padding-bottom: env(safe-area-inset-bottom);*/
	position: fixed;
	width: 100%;
}
.template .button--wrapper button {
	border-radius: 0;
	height: calc(48px + env(safe-area-inset-bottom));
	padding-bottom: env(safe-area-inset-bottom);
}
.button--wrapper--modal {
	background-color: rgba(0,0,0,0.5);
	bottom: 0;
	left: 0;
	/*opacity: 0;*/
	position: fixed;
	right: 0;
	top: 0;
	/*transform: translateX(100%);
	transition: 0.5s opacity ease;*/
}

/*CALCULATION TRANSITIONS*/
.calculation_modal_fade-enter-active, .calculation_modal_fade-leave-active {
  transition: 0.3s opacity ease;
}
.calculation_modal_fade-enter, .calculation_modal_fade-leave-to {
  opacity: 0;
}

.button--wrapper--modal.active {
	/*opacity: 1;
	transform: translateX(0);
	transition: 0.5s opacity ease;*/
}

.button--background {
	background-color: #fff;
	border-top: 1px solid #ddd;
	bottom: 0;
	left: 0;
	padding: 0.5rem 1rem calc(0.5rem + env(safe-area-inset-bottom)) 1rem;
	position: fixed;
	width: 100%;
}
.button--wrapper--combined {
	background-color: #fff;
	bottom: 0;
	box-shadow: 0 0px 8px rgba(0,0,0,0.2);
	left: 0;
	padding-bottom: calc(4rem + env(safe-area-inset-bottom));
	padding-top: 0.75rem;
	position: fixed;
	transform: translateY(calc(100% - 4rem));
	transition: 0.3s all ease;
	width: 100%;
}
.button--wrapper--combined.active {
	border-radius: 20px 20px 0 0;
	transform: translateY(0);
}
.button--wrapper--combined header {
	border-bottom: 1px solid #ccc;
	padding-left: 1rem;
	padding-right: 1rem;
}
.button--wrapper--combined header h2 {
	font-size: 21px;
}

.calculation_steps {
	border: none;
	padding: 1rem 1rem 1rem;
}
.calculation_steps li {
	border: none;
	display: flex;
	justify-content: space-between;
	margin-bottom: 1rem;
}
/*.calculation_steps li:last-of-type {
	margin-bottom: 1rem;
}*/
.calculation_steps li.calculation_steps--divider {
	justify-content: flex-end;
	padding-right: 1rem;
}


.calculation_steps--name {
	
}
.calculation_steps--name--code {
	font-weight: 700;
	line-height: 1em;
}
.calculation_steps--name--description {
	font-weight: 400;
}
.calculation_steps--amount {
	font-weight: 700;
}


.button--wrapper--combined--actions {
	display: flex;
	justify-content: space-between;
}
.button--wrapper--combined--actions .calculation {
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.button--wrapper--combined--actions .price {
	font-size: 19px;
	font-weight: 700;
	line-height: 1.5em;
}
.button--wrapper--combined--actions p {
	color: var(--blue);
	font-size: 14px;
	font-weight: 500;
	line-height: 1em;
}
.button--wrapper--combined--actions button {
	background-color: var(--blue);
	border-radius: 8px;
	color: #fff;
	height: 48px;
	/*padding-bottom: env(safe-area-inset-bottom);*/
	width: 50%;
}


.template--list {
	border-top: none;
	/*border-top: 1px solid #ddd;*/
}
.template--list li:not(.section_title) {
	background: #f3f3f3 url('/img/icon--check--empty.svg') no-repeat 0.5rem center;
	/*background-size: 20px 20px;*/
	border: none;
	border-radius: 8px;
	cursor: pointer;
	display: flex;
	margin-top: 0.25rem;
	min-height: 48px;
	padding: 0.5rem 0.5rem 0.5rem 2.5rem;
}
.template--list li.active {
	background: #f3f3f3 url('/img/icon--check--selected.svg') no-repeat 0.5rem center;
	/*background-size: 20px 20px;*/
}
.template--list li.other {
	background:  url('/img/icon--add--empty.svg') no-repeat 0.5rem center;
	/*background: none;*/
	color: var(--blue);
	justify-content: flex-start;
	font-size: 13px;
	font-weight: 600;
	text-transform: uppercase;
}
.template--list li.section_title {
	padding-top: 1rem;
	border: none;
}

.template--list--radio li.active {
	background: #f3f3f3 url('/img/icon--radio--selected.svg') no-repeat 0.5rem center;
	/*background-size: 20px 20px;*/
}
.template--list--remove li,
.template--list--remove li.active {
	background: #f3f3f3 url('/img/icon--remove.svg') no-repeat 0.5rem center;
}


/*MEL1 - PATIENTS & GROUPS */
.active_patients {
	margin-bottom: 0.25rem;
}
.active_patients li {
	align-items: center;
}
.template--list li.active_group {
	display: flex;
	justify-content: space-between;
	padding-bottom: 0;
	padding-right: 0.25rem;
	padding-top: 0;
}
.template--list li.active_group .group_count {
	color: #999;
	padding-right: 0.5rem;
}
.template--list li.active_group.active_group--in_claim .group_count {
	align-items: center;
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	border-left: 3px solid #fff;
	display: flex;
	height: 48px;
	padding: 0 1.5rem 0 0.75rem;
}


/*MEL1 - BILLING ITEMS*/
.template--list.billing_item li {
	align-items: center;
	justify-content: space-between;
}
.template--list.billing_item .details {
	
}
.template--list.billing_item .amount {
	font-size: 15px;
	white-space: nowrap;
}
.template--list.billing_item .amount:before {
	color: #aaa;
	content: "$";
	margin-right: 0.125rem;
}


.billing_item--code {
	font-size: 17px;
	font-weight: 700;
	line-height: 1.25em;
}
.billing_item--description {
	font-size: 14px;
	font-weight: 400;
	line-height: 1.25em;
}

/*MEL1 - DIAGNOSES*/
.template--list--wrapper {
	display: flex;
}
.template--list--diagnosis_indicator {
	align-items: center;
	display: flex;
	justify-content: center;
	line-height: 48px;
	width: 1.5rem;
}
.template--list.diagnoses {
	width: calc(100% - 1.5rem);
}
.template--list.diagnoses li {
	flex-direction: column;
	justify-content: center;
}


/*MEL1 - TEMPLATE COMBO*/
.template--list.billing_item.template_combo li,
.template--list.diagnoses.template_combo li {
	background: #f3f3f3;
	padding-left: 0.75rem;
}


/*MEL1 - REFERRING PHYSICIANS*/
.template--list.referring_physicians li {
	flex-direction: column;
	justify-content: center;
}
.template--list.referring_physicians li .physician--name {
	font-size: 16px;
	font-weight: 600;
	line-height: 1.25em;
}
.template--list.referring_physicians li .physician--number {
	font-size: 13px;
	font-weight: 400;
	line-height: 1.5em;
}
.name--first {
	font-weight: 500;
}

/*MEL1 - SERVICE LOCATION*/
.template--list.service_location li {
	/*flex-direction: column;
	justify-content: center;*/
	align-items: center;
	flex-direction: row-reverse;
	justify-content: flex-end;
	padding-left: 2.25rem;
}
.template--list.service_location li .service_location--name {
	color: #666;
	font-size: 16px;
	font-weight: 400;
	line-height: 1.25em;
	width: calc(100% - 1.5rem);
}
.template--list.service_location li .service_location--code {
	/*color: #999;*/
	font-size: 16px;
	font-weight: 700;
	line-height: 1.5em;
	margin-right: 0.5rem;
	text-align: center;
	width: 1.5rem;
}


/*MEL1 - START AND END TIMES*/
ul.set_time {
	border-top: none;
	display: flex;
	justify-content: space-between;
	padding-bottom: 0;
	padding-top: 0;
}
.set_time li {
	border: none;
	width: calc(50% - 0.5rem);
}
.set_time li button {
	align-items: center;
	background-color: #f7f7f7;
	border-radius: 8px;
	flex-direction: column;
	height: auto;
	padding-bottom: 0.5rem;
	padding-top: 0.75rem;
	width: 100%;
}
.set_time li.set_time--start button {
	/*border-right: 0.5px solid #ccc;*/
}
.set_time li button div:first-of-type {
	/*color: #999;*/
	font-size: 17px;
	font-weight: 600;
	margin-bottom: 0.25rem;
	/*text-transform: uppercase;*/
}
.set_time li:first-of-type button div:first-of-type {
	/*color: rgba(144,19,254,0.7);*/
}
.set_time li:last-of-type button div:first-of-type {
	/*color: #999;*/
}
.time {
	/*border-radius: 40px;*/
	/*color: #fff;*/
	/*border-bottom: 1.5px solid #999;*/
	font-size: 21px;
	font-weight: 600;
	letter-spacing: 1px;
	padding: 0.5rem 0.75rem;
}
.start_time {
	/*background: url('/img/icon--time--start.svg') no-repeat 0.5rem center;*/
	/*color: rgba(144,19,254,1);*/
	color: #333;
	/*padding-left: 3rem;*/
}
.end_time {
	/*background: url('/img/icon--time--end.svg') no-repeat 0.5rem center;*/
	color: #333;
	/*padding-left: 3rem;*/
}



/*MEL1 - NOTES*/
.input_notes {
	appearance: none;
	background-color: #f7f7f7;
	border: none;
	border-bottom: 1px solid #eee;
	border-top: 1px solid #eee;
	/*border-radius: 8px;*/
	font-size: 16px;
	margin-left:  -1rem;
	outline: none;
	padding: 0.5rem 1rem;
	resize: none;
	width: calc(100% + 2rem);
}





.title:first-of-type {
	margin-top: 1rem;
}
.title:not(:first-of-type) {
	/*border-bottom: 1px solid #ccc;*/
	display: flex;
	justify-content: space-between;
	margin-top: 2rem;
}
.title.title--condensed {
	margin-top: 1rem;
}
.title h5 {
	margin-bottom: 0;
}
.button--text {
	color: var(--blue);
	font-size: 13px;
	font-weight: 600;
	text-transform: uppercase;
}

.show_optional_fields {
	align-items: center;
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	/*border: 2px dashed #ddd;*/
	border-bottom: 1px solid #ccc;
	border-top: 1px solid #ccc;
	/*border-radius: 8px;*/
	color: #aaa;
	display: flex;
	font-weight: 500;
	height: 48px;
	justify-content: flex-start;
	margin-top: 2rem;
	/*padding-left: 1rem;*/
	width: 100%;
}


/*OPTIONAL FIELDS*/
.title--checkbox h5 {
	/*background: url('/img/icon--checkbox--empty.svg') no-repeat left center;
	background-size: 16px 16px;
	color: #999;
	padding-left: 1.25rem;*/
}


/*DATE SLIDER*/
.date_slider--wrapper {
	align-items: center;
	display: flex;
	flex-direction: row-reverse;
	margin-bottom: 1.5rem;
	margin-right: -1rem;
}
.date_slider {
	align-items: center;
	display: flex;
	flex-direction: row-reverse;
	justify-content: flex-start;
	margin-left: -1rem;
	overflow-x: scroll;
	width: calc(100% + 2rem - 48px);
}
.date_slider::-webkit-scrollbar {
	display: none;
}
.date_slider--calendar {
	background: url('/img/icon--calendar.svg') no-repeat center center;
	height: 48px;
	width: 48px;
}
.date_slider--cell {
	background-color: #f3f3f3;
	border-left: 1px solid #fff;
	padding-bottom: 0.25rem;
	padding-top: 0.25rem;
	text-align: center;
}
.date_slider--cell--day {
	font-size: 15px;
	font-weight: 600;
	line-height: 1.5em;
}
.date_slider--cell--date {
	color: #999;
	font-size: 14px;
	line-height: 1.5em;
	white-space: nowrap;
	width: 72px;
}
.date_slider--cell.active {
	background-color: #444;
	border-radius: 4px;
	padding-bottom: 0.5rem;
	padding-top: 0.5rem;
}
.date_slider--cell.active .date_slider--cell--day {
	color: #f3f3f3;
}


/*SLIDE UP*/
.search_input--wrapper {
	display: flex;
}
.search_input {
	-webkit-appearance: none;
	background-color: #F1F1F2;
	border: none;
	border-radius: 8px;
	height: 36px;
	margin-bottom: 1rem;
	margin-top: 1rem;
	outline: none;
	padding-left: 0.5rem;
	padding-right: 0.5rem;
	width: calc(100% - 64px);
}
.search--close {
	color: var(--blue);
	font-weight: 400;
	text-align: right;
	width: 64px;
}
.slide_up .template--list {
	height: calc(100vh - 20px - 5rem - 36px - env(safe-area-inset-bottom) - env(safe-area-inset-top));
	overflow-y: scroll;
	padding-bottom: 2rem;
}
.slide_up .template--list li {
	/*background: #f3f3f3;*/
}

.nav--claim {
	background-color: #fff;
	border-bottom: 1px solid #eee;
	margin-left: -1rem;
	position: sticky;
	top: 0;
	width: calc(100% + 2rem);
}
.nav--claim button {
	font-size: 17px;
	font-weight: 600;
	height: 48px;
	margin-left: 1rem;
	margin-right: 1rem;
}
.nav--claim button.active {
	border-bottom: 4px solid #007AFF;
}


.modalView--templates.add ul {
	margin-top: 2rem;
}
.modalView--templates.add li button {
	background: url('/img/icon--chevron--right.svg') no-repeat right center;
	font-size: 17px;
	height: 48px;
	text-align: left;
	width: 100%;
}
.for_you,
.speciality,
.new {
	padding: 1rem 1rem 4rem;
}



/*MODAL TRANSITIONS*/
.modal_fade-enter-active, .modal_fade-leave-active {
  transition: 0.3s opacity ease;
}
.modal_fade-enter, .modal_fade-leave-to {
  opacity: 0;
}
.slideUp_slide-enter-active, .slideUp_slide-leave-active {
  transition: 0.3s transform ease;
}
.slideUp_slide-enter, .slideUp_slide-leave-to {
  transform: translateY(100%);
}
</style>


